// src/testMode/randomData.js
// Random data for the test mode. Every function takes an optional rng (default Math.random)
// returning [0, 1) so tests can make it deterministic.

const FIRST_NAMES = [
    'Ada', 'Alan', 'Grace', 'Linus', 'Margaret', 'Dennis', 'Barbara', 'Ken', 'Radia', 'Tim',
    'Hedy', 'Edsger', 'Frances', 'Donald', 'Katherine', 'Guido', 'Joan', 'Bjarne', 'Anita', 'Brian',
];

const LAST_NAMES = [
    'Lovelace', 'Turing', 'Hopper', 'Torvalds', 'Hamilton', 'Ritchie', 'Liskov', 'Thompson', 'Perlman',
    'Berners-Lee', 'Lamarr', 'Dijkstra', 'Allen', 'Knuth', 'Johnson', 'Rossum', 'Clarke', 'Stroustrup',
    'Borg', 'Kernighan',
];

// A set is played to this many points; the loser ends anywhere below it.
export const WINNING_SCORE = 21;

export const pick = (items, rng = Math.random) => items[Math.floor(rng() * items.length)];

export function randomPlayerName(rng = Math.random) {
    return { firstName: pick(FIRST_NAMES, rng), lastName: pick(LAST_NAMES, rng) };
}

// Never a tie: one side gets WINNING_SCORE, the other 0..WINNING_SCORE-2.
export function randomSetScore(rng = Math.random) {
    const loserScore = Math.floor(rng() * (WINNING_SCORE - 1));
    return rng() < 0.5
        ? { team1: WINNING_SCORE, team2: loserScore }
        : { team1: loserScore, team2: WINNING_SCORE };
}
